import { render, staticRenderFns } from "./SquareBox.vue?vue&type=template&id=a34f494c&scoped=true&"
import script from "./SquareBox.vue?vue&type=script&lang=js&"
export * from "./SquareBox.vue?vue&type=script&lang=js&"
import style0 from "./SquareBox.vue?vue&type=style&index=0&id=a34f494c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34f494c",
  null
  
)

export default component.exports